import { getLabel } from '@apia/util';

export interface IRequiredMark {
  isFormReadonly?: boolean;
  isRequired?: boolean;
  isReadonly?: boolean;
}

/**
 * Muestra el * en los campos de requerido.
 */
export const RequiredMark = ({
  isFormReadonly = false,
  isRequired = false,
  isReadonly = false,
}: IRequiredMark) => {
  return isRequired && !isReadonly && !isFormReadonly ? (
    <abbr className="requiredMark" title={getLabel('msgReqField').text}>
      *
    </abbr>
  ) : null;
};
